import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators} from '@angular/forms';
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { Message, SpinnerService } from 'shared-components';
import { EtiquetadoService } from "../../../services/etiquetado.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
    selector: 'app-confecciones-edit-component',
    templateUrl: './edit.component.html'
})
export class ConfeccionesEditComponent implements OnInit {

    public _confeccion;

    public newEditForm: UntypedFormGroup;
    public showError: boolean;
    public mensajes = new Array<Message>();

    @Input() confeccionId;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() mensaje = new EventEmitter<string>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _etiquetadoService: EtiquetadoService,
        private readonly _dataProvider: DataProvider,
        private readonly _sessionContext: SessionContextService
    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            des: ['', Validators.required],
            alias: [''],
            activo: [''],
            etiquetador: [{value:'', disabled: true}],
            denominacion: [{value:'', disabled: true}],
            tipo: [{value:'', disabled: true}],
            pesoPallet: ['']
        });

        if (this.confeccionId) {
            this.getConfeccion();
        }
    }

    public getConfeccion() {
        this._spinnerService.showSpinner();
        this._etiquetadoService.getConfeccion(this.confeccionId).toPromise().finally(() => {
            this._spinnerService.hideSpinner();
        }).then((resp) => {
            this._confeccion = resp;
            this.newEditForm.patchValue({
                des: resp.des,
                alias: resp.alias,
                etiquetador: resp.desEtiquetador,
                denominacion: resp.desDenominacionUnica ? resp.desDenominacionUnica : 'Mix',
                tipo: resp.desTipoConfeccion,
                // peso: resp.cajasConfeccion[0].caja.kilos,
                activo: resp.activo
            });
            if(this._confeccion.tipoConfeccionId == 2) this.newEditForm.get('pesoPallet').reset(this._confeccion.kilos);
        });
    }

    public close() {
        this.refresh.emit(false);
    }

    public save()  {
        this.checkForm();
        if (this.newEditForm.valid && this.confeccionId) {
            this._confeccion = {
                id: this.confeccionId,
                des: this.newEditForm.get('des').value ? this.newEditForm.get('des').value : '' ,
                alias: this.newEditForm.get('alias').value ? this.newEditForm.get('alias').value : '',
                activo: this.newEditForm.get('activo').value ? this.newEditForm.get('activo').value : false
            };
            this._spinnerService.showSpinner();
            this._etiquetadoService.updateConfeccion(this._confeccion).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                  this.refresh.emit(true);
                  this.mensaje.emit('global.success.itemUpdated');
                },
                (error) => {
                  this.showError = true;
                  this.mensajes.push({ class: 'error', message: 'global.error.noResponse' });
                }
            );
        }
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.mensajes.push({ class: 'error', message: 'global.error.required' });
        }
    }
}
